import React from "react";
import { useTranslation } from "react-i18next";
import { Block, Row } from "@rentablo/components";
import { Rating } from "@rentablo/components";
import { FundamentalsBlockLayout } from "../FundamentalsBlockLayout";

export interface Props {
  isFetching?: boolean;
  fwwFundStars?: number;
  srri?: number;
}

export const RanksAndRisksContainer = ({
  isFetching = false,
  fwwFundStars,
  srri,
}: Props) => {
  const { t } = useTranslation();
  const title = t("fundamentals.ranksAndRisks.title");

  return (
    <FundamentalsBlockLayout
      title={title}
      isFetching={isFetching}
      stretch={false}
    >
      <Row>
        <Block
          title={t("fundamentals.ranksAndRisks.fwwFundStars")}
          toolTipDesc={t("fundamentals.ranksAndRisks.fwwFundStarsInfo")}
        >
          <Rating rating={fwwFundStars} />
        </Block>
      </Row>
      <Row>
        <Block
          title={t("fundamentals.ranksAndRisks.srri")}
          toolTipDesc={t("fundamentals.ranksAndRisks.srriInfo")}
        >
          <Rating rating={srri} variant="numbers" max={7} />
        </Block>
      </Row>
    </FundamentalsBlockLayout>
  );
};
